import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Column } from 'rbx';

import { replace, first, isUndefined, forEach } from 'lodash';
import ListingAudit from './ListingAudit';
import ClaimAudit from './ClaimAudit';
import ClaimedUserLoginDetails from './ClaimedUserLoginDetails';

import {
  Input,
  TextArea,
  Select,
  CheckBox,
  MobileInput,
  CreatableSelectInputs,
  InputErrorMessage,
} from '../../../components/elements';
import { getServicesTypes } from '../../../utils/fetchStatic';

const Container = styled.div`
  legend {
    background-color: #ffffff;
    padding: 0px 6px;
  }
`;

const parseInput = parseValue => {
  const final = [];
  parseValue.map((item, index) => {
    final.push({
      name: item.value,
      description: item.label,
      display_order: (index + 1).toString(),
    });
  });
  return final;
};

const parseData = parseValue => {
  const final = [];
  forEach(parseValue, item => {
    final.push({ value: item.name, label: item.description });
  });
  return final;
};

const Details = ({
  values,
  touched,
  errors,
  handleChange,
  handleBlur,
  setFieldValue,
  createForm,
  claim,
}) => {
  const [data, setData] = useState([
    {
      servicesTypes: [],
    },
  ]);
  useEffect(() => {
    const fetchData = async () => {
      const servicesTypes = await getServicesTypes();

      setData({
        servicesTypes,
      });
    };
    fetchData();
  }, []);
  console.log('values', values);
  return (
    <Container>
      <div className="label">Claim By Details</div>
      <Column.Group multiline vcentered gapSize={8}>
        <Column size="half">
          <Input
            action={['create_place_claimant']}
            label="Claimed User Contact Email"
            name="contact_email"
            id="PlaceManagement_PlaceClaimApproval_ClaimedUserContactEmail"
            value={values.contact_email}
            onChange={handleChange}
            onBlur={handleBlur}
            disabled={!createForm}
            errors={errors.contact_email}
            touched={touched.contact_email}
            required
          />
        </Column>
        <Column size="half">
          <MobileInput
            action={['create_place_claimant']}
            label="Claimed User Contact Phone"
            id="PlaceManagement_PlaceClaimApproval_ClaimedUserContactPhone"
            value={values.contact_phone}
            name="claimedUserPhone_Phone"
            onChange={value =>
              setFieldValue('contact_phone', replace(value, ' ', ''))
            }
            disabled={!createForm}
            errors={errors.contact_phone}
            touched={touched.contact_phone}
            required
          />
        </Column>
        <Column size="half">
          <Input
            action={['create_place_claimant']}
            label="Claimed User Business URL"
            name="contact_business_url"
            id="PlaceManagement_PlaceClaimApproval_ClaimedUserBusinessUrl"
            value={values.contact_business_url}
            onChange={handleChange}
            onBlur={handleBlur}
            disabled={!createForm}
            errors={errors.contact_business_url}
            touched={touched.contact_business_url}
          />
        </Column>
        <Column size="half">
          <Input
            action={['create_place_claimant']}
            label="Claimed User Linkedin Profile URL"
            name="contact_linked_in_url"
            id="PlaceManagement_PlaceClaimApproval_ClaimedUserLinkedinProfileUrl"
            value={values.contact_linked_in_url}
            onChange={handleChange}
            onBlur={handleBlur}
            disabled={!createForm}
            errors={errors.contact_linked_in_url}
            touched={touched.contact_linked_in_url}
          />
        </Column>
        {isUndefined(values.service_type) ? (
          <Column size="half">
            <CreatableSelectInputs
              action={['create_place_claimant']}
              label="Interested Services"
              id="PlaceManagement_PlaceClaimApproval_InterestedServices"
              suggestions={parseData(data.servicesTypes)}
              value=""
              onChange={value => {
                if (value) {
                  setFieldValue('service_type', parseInput(value));
                }
              }}
              disabled={!createForm}
              errors={errors.service_type}
              touched={touched.service_type}
            />
          </Column>
        ) : (
          <Column size="half">
            <CreatableSelectInputs
              action={['create_place_claimant']}
              label="Interested Services"
              id="PlaceManagement_PlaceClaimApproval_InterestedServices"
              suggestions={parseData(data.servicesTypes)}
              value={values.service_type.map(item => ({
                value: item.name,
                label: item.description,
              }))}
              onChange={value => {
                if (value) {
                  setFieldValue('service_type', parseInput(value));
                }
              }}
              disabled={!createForm}
              errors={errors.service_type}
              touched={touched.service_type}
            />
          </Column>
        )}
        <Column size="half">
          <CheckBox
            action={['create_place_claimant']}
            label=" Authority Term Of Service & Claim Acknowledged"
            id="PlaceManagement_PlaceClaimApproval_AuthorityTermOfService&ClaimAcknowledged"
            value={values.agree_terms_and_conditions}
            onChange={value => {
              if (value) {
                setFieldValue('agree_terms_and_conditions', value);
              }
            }}
            disabled={!createForm}
            required
          />

          <InputErrorMessage
            errors={errors.agree_terms_and_conditions}
            touched={touched.agree_terms_and_conditions}
          />
        </Column>
        <Column size="half">
          <Column.Group gapSize={1}>
            <Column size="half">
              <Select
                action={['create_place_claimant']}
                label="Claimed User Verification"
                id="PlaceManagement_PlaceClaimApproval_ClaimedUserVerification"
                options={[
                  { value: 'SMS', label: 'SMS' },
                  { value: 'FACEBOOK', label: 'FACEBOOK' },
                  { value: 'PHONE', label: 'PHONE' },
                  { value: 'MANUAL', label: 'MANUAL' },
                  { value: 'CREDIT CARD', label: 'CREDIT CARD' },
                ]}
                value={[
                  {
                    value: first(values.verification_mode),
                    label: first(values.verification_mode),
                  },
                ]}
                onChange={value => {
                  setFieldValue('verification_mode', [value.value]);
                }}
                disabled={!createForm}
              />
            </Column>
            <Column size="half">
              <Input
                action={['create_place_claimant']}
                label="Claimed User Role"
                name="contact_role"
                id="PlaceManagement_PlaceClaimApproval_ClaimedUserRole"
                value={values.contact_role}
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={!createForm}
                errors={errors.contact_role}
                touched={touched.contact_role}
                required
              />
            </Column>
          </Column.Group>
        </Column>
        <Column size="half">
          <Input
            action={['create_place_claimant']}
            label="Claimed User Full Name"
            name="contact_full_name"
            id="PlaceManagement_PlaceClaimApproval_ClaimedUserFullName"
            value={values.contact_full_name}
            onChange={handleChange}
            onBlur={handleBlur}
            disabled={!createForm}
            errors={errors.contact_full_name}
            touched={touched.contact_full_name}
            required
          />
        </Column>
        {isUndefined(values.verification_note) ? (
          <Column size="full">
            <TextArea
              action={['create_place_claimant', 'action_place_claimant']}
              label="Verification Comments"
              name="verification_note"
              id="PlaceManagement_PlaceClaimApproval_VerificationComments"
              onChange={handleChange}
              onBlur={handleBlur}
              errors={errors.verification_note}
              touched={touched.verification_note}
              required
            />
          </Column>
        ) : (
          <Column size="full">
            <TextArea
              action={['create_place_claimant', 'action_place_claimant']}
              label="Verification Comments"
              name="verification_note"
              id="PlaceManagement_PlaceClaimApproval_VerificationComments"
              value={values.verification_note}
              onChange={handleChange}
              onBlur={handleBlur}
              errors={errors.verification_note}
              touched={touched.verification_note}
              required
            />
          </Column>
        )}
      </Column.Group>
      {isUndefined(claim) || isUndefined(claim.audit) ? (
        <fieldset className="box">
          <legend className="label">Claimed User Login Details</legend>
          <Column.Group multiline vcentered gapSize={8}>
            <Column size="half">
              <Input label="Claimed by FullName" disabled />
            </Column>
            <Column size="half">
              <Input label="Claimed by Email" disabled />
            </Column>
            <Column size="half">
              <MobileInput label="Claimed by Phone" disabled />
            </Column>
            <Column size="half">
              <Input label="Claim Date & Time" disabled />
            </Column>
          </Column.Group>
        </fieldset>
      ) : (
        <ClaimedUserLoginDetails
          createdBy={claim.audit.created_by}
          createdAt={claim.audit.created_at}
        />
      )}

      <ListingAudit
        values={values}
        approvedBy={values.listing_audit.listing_approved_by}
        approvedAt={values.listing_audit.listing_approved_at}
      />

      <ClaimAudit
        values={values}
        approvedBy={values.place_claimant_audit.claim_approved_by}
        approvedAt={values.place_claimant_audit.claim_approved_at}
      />
    </Container>
  );
};

export default Details;
